import { render } from "./ReportesUso.vue?vue&type=template&id=51056a01"
import script from "./ReportesUso.vue?vue&type=script&lang=js"
export * from "./ReportesUso.vue?vue&type=script&lang=js"

import "./ReportesUso.vue?vue&type=style&index=0&id=51056a01&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__